// mutation types
export const SET_CONTENTS = "setContents";

export default {
  state: {
    contents: []
  },

  mutations: {
    [SET_CONTENTS](state, contents) {
      state.contents = contents;
    }
  },

  actions: {
    setContents({ commit }, contents) {
      commit(SET_CONTENTS, contents);
    }
  },

  getters: {
    contents: state => state.contents
  }
};
